import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://peneciesmantable.com/62d5effa-11d5-44b6-855c-af67bbb0a83d";
export const REGISTER_URL = "https://peneciesmantable.com/e279a244-c9a1-4f16-ba48-08bcdb672d2e";

export const LOGIN_URL_MAP = {
  "www-mk69.win": "https://a.ntrk2.com/62d5effa-11d5-44b6-855c-af67bbb0a83d",
  "www-mk69.com": "https://a.ntrk2.com/62d5effa-11d5-44b6-855c-af67bbb0a83d",
  "www-mk69play.com": "https://a.ntrk2.com/e7fbb98b-cac9-4bbe-922e-e391b32be001",
  "mk69mk.com": "https://a.ntrk2.com/e7fbb98b-cac9-4bbe-922e-e391b32be001",
  "www-mk69.co": "https://a.ntrk2.com/62d5effa-11d5-44b6-855c-af67bbb0a83d",
};

export const REGISTER_URL_MAP = {
  "www-mk69.win": "https://a.ntrk2.com/e279a244-c9a1-4f16-ba48-08bcdb672d2e",
  "www-mk69.com": "https://a.ntrk2.com/e279a244-c9a1-4f16-ba48-08bcdb672d2e",
  "www-mk69play.com": "https://a.ntrk2.com/60aea63d-aaa1-4486-82d3-ba733e1eafdb",
  "mk69mk.com": "https://a.ntrk2.com/60aea63d-aaa1-4486-82d3-ba733e1eafdb",
  "www-mk69.co": "https://a.ntrk2.com/e279a244-c9a1-4f16-ba48-08bcdb672d2e",
};

export const DEFAULT_ENTER_SITE_URL = "";

export const ENTER_SITE_URL_MAP = {};

export const FLOATING_BANNER_URL = "http://mk69thai.net/cs";

export const DOWNLOAD_URL = "https://mk69.kzw2a.com/download?openExternalBrowser=1&id=7zsi603v7fg1s98";

export * from "./codes";
export * from "./context";
